<template>
  <div class="lightingSystem">
    <div class="row ashComWrap">
      <div class="comTitle">
        <h4>照明系统概览</h4>
      </div>
      <div class="comContentBox">
        <ul>
          <li
            v-for="(v, i) in overviewList"
            :key="i"
            style="margin-bottom: 20px"
          >
            <div class="dataBox" style="height: 100%">
              <p>{{ v.name }}</p>
              <h5>
                {{ v.value }} <span>{{ v.unit }}</span>
              </h5>
            </div>
            <!-- <div class="chartsBox">
              <PublicEcharts
                :id="'overviewCharts' + i"
                :chartsData="v"
                :type="'scaleCharts'"
              />
            </div> -->
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="row1 ashComWrap">
      <div class="comTitle">
        <h4>照明系统实时功率</h4>
      </div>
      <div
        class="comContentBox"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="ratedPower">
          <div style="width: 90%; height: 100%; margin: 0 auto">
            <div class="dataBox">
              <p>{{ ratedPower.name }}</p>
              <h5>
                {{ ratedPower.value }} <span>{{ ratedPower.unit }}</span>
              </h5>
            </div>
            <div class="chartsBox">
              <PublicEcharts
                :id="'row1'"
                :chartsData="ratedPower"
                :type="'scaleCharts'"
              />
            </div>
          </div>
        </div>
        <div class="lightingChart secondAshComWrap">
          <div class="comTitle">
            <h4>公共区域照明实时功率TOP5</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts
              :id="'barCharts'"
              :chartsData="publicAreaCharts"
              :type="'horizontalBar'"
            />
          </div>
        </div>
        <div class="lightingChart secondAshComWrap">
          <div class="comTitle">
            <h4>建筑空间照明实时功率TOP5</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts
              :id="'barCharts1'"
              :chartsData="buildingSpaceCharts"
              :type="'horizontalBar'"
            />
          </div>
        </div>
      </div>
    </div> -->
    <div class="row1 ashComWrap">
      <div class="comTitle">
        <h4>照明系统设备</h4>
      </div>
      <div
        class="comContentBox"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="ammeter secondAshComWrap">
          <div class="comTitle">
            <h4>远程电表</h4>
          </div>
          <div class="comContentBox equipmentCom">
            <ul>
              <li v-for="(v, i) in ammeterList.fourType" :key="i">
                <h5>{{ v.value }}</h5>
                <p>{{ v.name }}</p>
              </li>
            </ul>
            <!-- <div class="charts">
              <PublicEcharts
                :id="'ammeter'"
                :chartsData="ammeterList"
                :type="'scaleCharts'"
              />
            </div> -->
          </div>
        </div>
        <div class="control secondAshComWrap">
          <div class="comTitle">
            <h4>控制开关</h4>
          </div>
          <div class="comContentBox equipmentCom">
            <ul>
              <li v-for="(v, i) in controlList.fourType" :key="i">
                <h5>{{ v.value }}</h5>
                <p>{{ v.name }}</p>
              </li>
            </ul>
            <div class="charts">
              <PublicEcharts
                :id="'control'"
                :chartsData="controlList"
                :type="'scaleCharts'"
              />
            </div>
          </div>
        </div>
        <div class="sensor secondAshComWrap">
          <div class="comTitle">
            <h4>智能传感器</h4>
          </div>
          <div class="comContentBox">
            <ul>
              <li v-for="v in sensorList" :key="v.name">
                <h5>{{ v.name }}({{ v.total }})</h5>
                <div class="txtBox">
                  <p>{{ v.onLine }}</p>
                  <p>{{ v.offLine }}</p>
                  <p>{{ v.alarm }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="tableBox">
      <div class="alarmTable">
        <AlarmOrderTable :type="'alarm'" :deviceType="'照明系统'" />
      </div>
      <div class="workOrderTable">
        <AlarmOrderTable :type="'order'" :deviceType="'照明系统'" />
      </div>
    </div>
  </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts";
import AlarmOrderTable from "@/components/fenxizujian/AlarmOrderTable.vue";
import { dealBigNum } from "@/assets/js/utils";
import api from "@/api";
export default {
  components: {
    PublicEcharts,
    AlarmOrderTable,
  },
  data() {
    return {
      overviewList: [
        { dataArr: [] },
        { dataArr: [] },
        { dataArr: [] },
        { dataArr: [] },
      ],
      ratedPower: {
        dataArr: [],
      },
      publicAreaCharts: {
        unit: "kw·h",
        xData: [],
        yData: [],
      },
      buildingSpaceCharts: {
        unit: "kw·h",
        xData: [],
        yData: [],
      },
      ammeterList: {
        fourType: [],
        dataArr: [],
      },
      controlList: {
        fourType: [],
        dataArr: [],
      },
      sensorList: [],
    };
  },
  methods: {
    async getOverview() {
      let res = await api.lightingOSGetOverview({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.overviewList = Array.from(res.data.data)
          .map((item) => ({
            name: item.name,
            unit: item.unit,
            value: dealBigNum(item.value),
            dataArr: item.charts,
          }))
          .filter((v) => {
            return v.name !== "实时功率";
          });
      }
    },
    async getRatedPower() {
      let res = await api.lightingOSGetRatedPower({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.ratedPower = res.data.data.find((v) => {
          return v.name == "base";
        }).value;
        this.ratedPower.dataArr = this.ratedPower.charts;

        let publicArea = res.data.data.find((v) => {
          return v.name == "publicArea";
        }).value;
        publicArea.slice(0, 5).map((v) => {
          this.publicAreaCharts.xData.push(v.value);
          this.publicAreaCharts.yData.push(v.name);
        });
        let buildingSpace = res.data.data.find((v) => {
          return v.name == "buildingSpace";
        }).value;
        buildingSpace.slice(0, 5).map((v) => {
          this.buildingSpaceCharts.xData.push(v.value);
          this.buildingSpaceCharts.yData.push(v.name);
        });
      }
    },
    async systemDevice() {
      let res = await api.lightingOSGetDevice({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.ammeterList = res.data.data.wattHourMeter;
        this.ammeterList.dataArr = this.ammeterList.twoType;
        this.controlList = res.data.data.switch;
        this.controlList.dataArr = this.controlList.twoType;
        this.sensorList = res.data.data.sensor;
      }
    },
  },
  created() {
    this.getOverview();
    this.getRatedPower();
    this.systemDevice();
  },
};
</script>

<style lang="scss" scoped>
.lightingSystem {
  width: 100%;
  overflow: auto;
  .row {
    width: $innerWidth;
    height: 150px;
    margin: 16px auto 12px;
    ul {
      width: 98%;
      margin: 0 auto;
      height: 100%;
      @include setFlexBetween;
      li {
        width: 16%;
        height: 100%;
        .dataBox,
        .chartsBox {
          width: 100%;
          height: 50%;
        }
        .dataBox {
          @include setFlexColumn;
          justify-content: flex-end;
          p {
            font-size: 18px;
            font-weight: bold;
          }
          h5 {
            font-size: 30px;
            color: #333;
            margin: 5px 0 0;
            span {
              font-size: 14px;
              font-weight: normal;
              color: #999;
            }
          }
        }
      }
    }
  }
  .row1 {
    width: $innerWidth;
    height: 300px;
    margin: 0 auto 12px;
    .ratedPower {
      width: 22%;
      height: 100%;
      .dataBox,
      .chartsBox {
        width: 100%;
        height: 50%;
      }
      .dataBox {
        @include setFlexColumn;
        justify-content: flex-end;
        p {
          font-size: 18px;
          font-weight: bold;
        }
        h5 {
          font-size: 30px;
          color: #333;
          margin: 5px 0 0;
          span {
            font-size: 14px;
            font-weight: normal;
            color: #999;
          }
        }
      }
    }
    .lightingChart {
      width: 38%;
      height: 100%;
    }
    .ammeter {
      width: 27%;
      height: 100%;
    }
    .equipmentCom {
      ul {
        width: 90%;
        height: 50%;
        margin: 0 auto;
        @include setFlexBetween;
        li {
          text-align: center;
          width: 25%;
          h5 {
            font-size: 22px;
            margin-bottom: 10px;
          }
        }
      }
      .charts {
        width: 100%;
        height: 50%;
      }
    }
    .control {
      width: 27%;
      height: 100%;
    }
    .sensor {
      width: 45%;
      height: 100%;
      ul {
        width: 96%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-items: flex-start;
        overflow: auto;
        li {
          width: 45%;
          height: 80px;
          border-radius: 4px;
          border: 1px solid #e3e3e3;
          margin-bottom: 15px;
          margin-right: 2%;
          h5 {
            height: 32px;
            line-height: 32px;
            color: #20558c;
            font-size: 13px;
            background: #deeeff;
            text-align: center;
          }
          .txtBox {
            @include setFlexAround;
            height: 48px;
            p {
              font-weight: bold;
              font-size: 16px;
              color: #666;
            }
            p:nth-child(1) {
              color: #037cff;
            }
            p:nth-child(3) {
              color: #fa6400;
            }
          }
        }
      }
    }
  }
  .tableBox {
    width: $innerWidth;
    height: 500px;
    margin: 0 auto 16px;
    @include setFlexBetween;
    .alarmTable,
    .workOrderTable {
      width: $halfWidth;
      height: 100%;
    }
  }
}
</style>
